export type OS = "mac" | "windows" | "other";

export const getOS = (): OS => {
  if (typeof navigator === "undefined") return "other";
  const ua = navigator.userAgent || "";
  if (/Mac|iPhone|iPad|iPod/i.test(ua)) return "mac";
  if (/Win/i.test(ua)) return "windows";
  return "other";
};

export const isMac = (): boolean => getOS() === "mac";
